import React from 'react';

const CalendarPage = () => {
  return (
    <div className="container py-4">
      <h4 className="mb-4">Doctor Calendar</h4>
      <p>This page will display the doctor's scheduled appointments in a calendar view.</p>
      {/* Integrate a calendar like react-calendar or FullCalendar here */}
    </div>
  );
};

export default CalendarPage;